/**
 * Qual card segura a tela no lugar quando a lista muda de ordem.
 *
 * É o primeiro card visível que continua na lista e não subiu. O que subiu não
 * serve: é ele que está saindo dali. Sem nenhum assim (tudo que estava na tela
 * saiu ou subiu), devolve null e a lista fica como o navegador deixar.
 *
 * Compara só os cards que estão nas duas listas: quando um atendimento sai, os
 * de baixo andam uma posição, mas não subiram.
 */
export function cardDeReferencia(
  visiveis: readonly number[],
  antes: readonly number[],
  depois: readonly number[],
): number | null {
  const eram = new Set(antes);
  const ficaram = new Set(depois);
  const posicaoAntes = new Map(antes.filter((id) => ficaram.has(id)).map((id, i) => [id, i]));
  const posicaoDepois = new Map(depois.filter((id) => eram.has(id)).map((id, i) => [id, i]));
  for (const id of visiveis) {
    const velha = posicaoAntes.get(id);
    const nova = posicaoDepois.get(id);
    if (velha === undefined || nova === undefined) continue;
    if (nova >= velha) return id;
  }
  return null;
}

export function mesmaOrdem(a: readonly number[], b: readonly number[]): boolean {
  return a.length === b.length && a.every((id, i) => id === b[i]);
}
